<template>
  <div>
    <v-alert type="warning" :value="true">Keine Berechtigung</v-alert>
  </div>
</template>
<script>
export default {
  name: 'NotAuthorized',
  data() {
    return {
      isLoading: true
    };
  },
  mounted() {
    console.log('not authorized');
  }
};
</script>
